import { connect } from "react-redux";
import NoPhaiThu from "components/NoPhaiThu";
import { getListNoPhaiThu } from "actions/NoPhaiThu";
import { showModalGuiTinNhan } from "actions/GuiTinNhan";
import { showModalGuiEmail } from "actions/GuiEmail";
import { getComboUser } from "actions/User";
import { getPhanQuyenNoPhaiThu } from "actions/PhanQuyen";
import { showModalGiaHanNoPhaiThu } from "actions/GiaHanNoPhaiThu";
import { showModalGhiChuChoVay } from "actions/GhiChuChoVay";
import { showInPhieuThuChi } from "actions/InThuChi";
import { getConfig } from "actions/CauHinh";
import { getLanDongLaiChoVay } from "actions/QuanLyChoVay";
const mapStateToProps = (state) => ({
  nophaithu: state.nophaithu,
  user: state.user,
  phanquyen: state.phanquyen,
  inthuchi: state.inthuchi,
  giahannophaithu: state.giahannophaithu,
  ghichuchovay: state.ghichuchovay,
  cauhinh: state.cauhinh,
});

const mapDispatchToProps = (dispatch) => ({
  getListNoPhaiThu: (dataSearch) => dispatch(getListNoPhaiThu(dataSearch)),
  showModalGuiEmail: () => dispatch(showModalGuiEmail()),
  showModalGuiTinNhan: () => dispatch(showModalGuiTinNhan()),
  getComboUser: () => dispatch(getComboUser()),
  getPhanQuyenNoPhaiThu: () => dispatch(getPhanQuyenNoPhaiThu()),
  showModalGiaHanNoPhaiThu: () => dispatch(showModalGiaHanNoPhaiThu()),
  showModalGhiChuChoVay: () => dispatch(showModalGhiChuChoVay()),
  showInPhieuThuChi: (thuChiId) => dispatch(showInPhieuThuChi(thuChiId)),
  getConfig: () => dispatch(getConfig()),
  getLanDongLaiChoVay: (dataSearch) =>
    dispatch(getLanDongLaiChoVay(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NoPhaiThu);
